import { type ReactNode } from 'react'
import { Alert, type Variant } from 'ui/src/components/Alert/Alert'
import { CampaignIcon } from 'ui/src/icons/CampaignIcon'
import { InfoIcon } from 'ui/src/icons/InfoIcon'

export type DiscountInfoCardProps = {
  content: ReactNode
  variant: Extract<Variant, 'success' | 'infoInline'>
}

export function DiscountInfoCard({ content, variant }: DiscountInfoCardProps) {
  const icon = variant === 'success' ? CampaignIcon : InfoIcon

  return (
    <Alert.Root variant={variant}>
      <Alert.Icon icon={icon} />
      <Alert.Body>
        <Alert.Message>{content}</Alert.Message>
      </Alert.Body>
    </Alert.Root>
  )
}
